export default {
  MOSHI_ID: 4, // 1: なすぐらむ, 2:ほけもし, 3:さんもし, 4:かんもし, 5:かんもし
  YEAR: 2026,
  API_SERVER_HOSTNAME:
    process.env.REACT_APP_API_SERVER || "https://kanmoshi-api.intermed.co.jp", //production
  //API_SERVER_HOSTNAME: "https://nsmsd-api.intermed.co.jp", //demo
  //API_SERVER_HOSTNAME: "https://nsmsd-api.intermed.co.jp:3000", //test dev
  // API_SERVER_HOSTNAME: "http://localhost:3000", //local (use npm run start-dev)
  //API_SERVER_HOSTNAME: "http://kanmoshi-demo.intermed.co.jp",

  DB_AM_PM_PROBLEM_COUNT: 100,

  //COLOSRS
  COLOR_REQUIRED_SUCCESS_MAIN: "#bded9a",
  COLOR_REQUIRED_FAILURE_MAIN: "#D9D9D9",
  COLOR_REQUIRED_SUCCESS_SUB: "#e5f8d7",
  COLOR_REQUIRED_FAILURE_SUB: "#F2F2F2",

  COLOR_NORMAL_SITUATION_A_MAIN: "#FFFFD9",
  COLOR_NORMAL_SITUATION_B_MAIN: "#FFE699",
  COLOR_NORMAL_SITUATION_C_MAIN: "#FFD9D9",
  COLOR_NORMAL_SITUATION_D_MAIN: "#FFB3B3",
  COLOR_NORMAL_SITUATION_E_MAIN: "#FF6565",
  COLOR_NORMAL_SITUATION_A_SUB: "#FFFFF7",
  COLOR_NORMAL_SITUATION_B_SUB: "#FFF8E1",
  COLOR_NORMAL_SITUATION_C_SUB: "#FFF7F7",
  COLOR_NORMAL_SITUATION_D_SUB: "#FFF3F3",
  COLOR_NORMAL_SITUATION_E_SUB: "#FFDDDD",

  COLOR_SUBJECT_REQUIRED_MAIN: "#FCCE7C",
  COLOR_SUBJECT_NORMAL_MAIN: "#B5D6FD",
  COLOR_SUBJECT_SITUATION_MAIN: "#FED2D3",
  COLOR_SUBJECT_NORMAL_SITUATION_MAIN: "#81D4E7",

  COLOR_SUBJECT_REQUIRED_SUB: "#FEF3DE",
  COLOR_SUBJECT_NORMAL_SUB: "#E8F2FE",
  COLOR_SUBJECT_SITUATION_SUB: "#FFEFEF",
  COLOR_SUBJECT_NORMAL_SITUATION_SUB: "#E6F6FA",

  CATEGORY_SHORT: [
    null,
    "社",
    "解医",
    "食品",
    "基",
    "応",
    "教",
    "臨",
    "公",
    "給",
    "応試",
  ],

  CLASS_BUNDARY: {
    A: 65,
    B: 60,
    C: 50,
    D: 40,
    E: 30,
  },
  CLASS_BORDER_DESCRIPTION: {
    A: "総合得点130点以上（得点率65％以上）",
    B: "総合得点120点以上（得点率60％以上）",
    C: "総合得点100点以上（得点率50％以上）",
    D: "総合得点80点以上（得点率40％以上）",
    E: "総合得点80点未満（得点率40％未満）",
  },

  judgeClass(rate) {
    if (rate >= this.CLASS_BUNDARY["A"]) {
      return "A";
    } else if (rate >= this.CLASS_BUNDARY["B"]) {
      return "B";
    } else if (rate >= this.CLASS_BUNDARY["C"]) {
      return "C";
    } else if (rate >= this.CLASS_BUNDARY["D"]) {
      return "D";
    } else {
      return "E";
    }
  },
};
